import React from 'react';
import PropTypes from 'prop-types';
import {FormGroup, FormControl, FormHelperText} from '@material-ui/core';
import {KeyboardArrowLeft, KeyboardArrowRight} from '@material-ui/icons';
import {isEmpty} from 'lodash/lang';
import {formShape} from 'rc-form';
import {DateTimePicker as MuiDateTimePicker, DatePicker as MuiDatePicker} from '@material-ui/pickers';

const Picker = React.forwardRef(({component, ...restProps}, ref) =>
  React.createElement(component, {
    autoOk: true,
    leftArrowIcon: <KeyboardArrowLeft />,
    rightArrowIcon: <KeyboardArrowRight />,
    showTodayButton: true,
    ...restProps,
  }),
);

Picker.propTypes = {
  component: PropTypes.any.isRequired,
};

const DateTimePickerField = ({
  name,
  label,
  rules,
  initialValue,
  helpText,
  maxDate,
  minDate,
  form: {getFieldDecorator, getFieldError},
  withTime,
  hideErrorText,
  ...restProps
}) => {
  let errors = getFieldError(name);
  let hasError = !isEmpty(errors);
  let error;
  if (hasError) {
    error = errors[0];
  }

  return (
    <FormGroup className="mui-form-group">
      <FormControl error={hasError}>
        {getFieldDecorator(name, {
          validate: [
            {trigger: 'onBlur', rules},
            {trigger: 'onChange', rules},
          ],
          initialValue,
        })(
          <Picker
            component={withTime ? MuiDateTimePicker : MuiDatePicker}
            {...{
              name,
              label,
              format: withTime ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD',
              maxDate,
              minDate,
              ...restProps,
            }}
          />,
        )}
        {helpText && <FormHelperText error={false}>{helpText}</FormHelperText>}
        {!hideErrorText && <FormHelperText error={hasError}>{error}</FormHelperText>}
      </FormControl>
    </FormGroup>
  );
};

DateTimePickerField.propTypes = {
  form: formShape,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  rules: PropTypes.array.isRequired,
  initialValue: PropTypes.object,
  helpText: PropTypes.string.isRequired,
  maxDate: PropTypes.object,
  minDate: PropTypes.object,
  withTime: PropTypes.bool.isRequired,
  hideErrorText: PropTypes.bool.isRequired,
};

DateTimePickerField.defaultProps = {
  rules: [],
  initialValue: null,
  helpText: '',
  withTime: true,
  hideErrorText: false,
};

export default DateTimePickerField;
